import "MWL@2026/presentation/capabilities/color-switch";
import "MWL@2026/widgets/code/code-script";

import "WebSlides@2026/presentation/capabilities/";
import "WebSlides@2026/widgets/frames/";

// we need the slides to be declared before being able to navigate.
import "WebSlides@2026/presentation/navigator";